
import { Outlet, Navigate } from 'react-router-dom';
import { usePermissions } from '@/contexts/unified-permissions';
import { LoadingState } from '@/components/ui/loading-state';

export const PremiumRoute = () => {
  const { isPremium, permissionsStatus } = usePermissions();

  if (permissionsStatus === 'loading') {
    return (
      <LoadingState
        title="Checking subscription"
        description="Verifying your premium status..."
        size="md"
        fullScreen={true}
      />
    );
  }

  if (!isPremium) {
    // Redirect to subscription page instead of showing placeholder
    return <Navigate to="/subscription" replace />;
  }

  // If subscribed, render the child routes
  return <Outlet />;
};
